var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "18", height: "16", viewBox: "0 0 18 16", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.563 8.201L.992 11.265l-.766-.642L8.582.664l9.192 7.713-5.785 6.895-8.426-7.07zm9.589 4.13l1.928-2.298-7.66-6.428L5.49 5.903l7.66 6.428zm-.643.766l-7.66-6.428-.643.766 7.66 6.428.643-.766zm3.214-3.83l.643-.766-7.66-6.428-.644.766 7.66 6.428z", fill: "#000", fillRule: "evenodd" })
  );
});